import { BulletList as OriginalBulletList } from "@tiptap/extension-list";

export const BulletList = OriginalBulletList.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "flex-1 pl-4 sm:pl-7 list-disc [&>li>p]:my-0",
      },
    };
  },
});
